import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWishlist } from '../context/WishlistContext';
import { trackFacebookEvent } from '../utils/facebookPixel';
import ProductCard from '../components/product/ProductCard';
import './Wishlist.css';

const Wishlist: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { items, clearWishlist } = useWishlist();
  const currentLang = i18n.language;

  // Track ViewContent for wishlist page
  useEffect(() => {
    if (items.length > 0) {
      trackFacebookEvent('ViewContent', {
        content_name: 'Wishlist',
        content_ids: items.map(item => item.id.toString()),
        content_type: 'product_group',
        num_items: items.length
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.length]);

  const handleContinueShopping = () => {
    trackFacebookEvent('Search', {
      search_string: 'browse_products',
      content_type: 'product'
    });
    navigate('/products');
  };

  if (items.length === 0) {
    return (
      <div className="wishlist-page">
        <div className="container">
          <div className="empty-wishlist">
            <h2>{t('common.noData') || 'No Wishlist Items'}</h2>
            <p>{currentLang === 'bn' ? 'আপনার ইচ্ছাতালিকা খালি' : 'Your wishlist is empty'}</p>
            <button 
              onClick={handleContinueShopping} 
              className="continue-btn"
            >
              {t('cart.continueShopping')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="container">
        <div className="wishlist-header">
          <h1>{currentLang === 'bn' ? 'আমার ইচ্ছাতালিকা' : 'My Wishlist'}</h1>
          <button className="clear-wishlist-btn" onClick={clearWishlist}>
            {currentLang === 'bn' ? 'সব মুছুন' : 'Clear All'}
          </button>
        </div>

        <div className="wishlist-grid">
          {items.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
